import { Moment } from "moment";
import { PeriodAndSurveyTypeFilters } from "../../../components/filters/models/periodAndSurveyTypeFilters";
import _ from "lodash";
import moment from "moment";

export type Rolling = 'YEAR_TO_DATE' | 'TWELVE_MONTHS' | 'SIX_MONTHS' | 'THREE_MONTHS' | 'ONE_MONTH';
export type SurveyType = 'FULLY_COMPLETED' | 'PARTIALLY_COMPLETED';
export type warranty = 'IN_BASE_WARRANTY_PERIOD' | 'OUT_OF_BASE_WARRANTY_PERIOD';
export type Uptime = 'YES' | 'NO';
export interface IPeriodAndSurveyType {
  rolling: Rolling;
  current: IPeriod;
  previous: IPeriod;
  surveyTypes: SurveyType[],
  warranties: warranty[],
  uptimes: Uptime[],
  flowChart?: string
}

export interface IPeriod {
  from: number,
  to: number
}

export class PeriodAndSurveyType implements IPeriodAndSurveyType {
  rolling: Rolling = 'ONE_MONTH';

  surveyTypes: SurveyType[] = [];
  warranties: warranty[] = [];
  uptimes: Uptime[] = [];

  current: IPeriod = {
    from: 0,
    to: 0
  }

  previous: IPeriod = {
    from: 0,
    to: 0
  }

  constructor(filters?: PeriodAndSurveyTypeFilters) {
    if (filters) {
      this.rolling = filters.rolling;
      let utcMonth = filters.month;
      this.current = this.getPeriods(utcMonth, filters.rolling);
      this.previous = this.getPeriods(_.cloneDeep(utcMonth).subtract(1, "month").endOf('month'), filters.rolling);
      this.surveyTypes = filters.surveyTypes;
      this.warranties = filters.warranties;
      this.uptimes = filters.uptimes;
    }
  }

  private getPeriods(month: Moment, rolling: Rolling): IPeriod {
    let to: Moment = _.cloneDeep(month).endOf('month');
    if (to.month() == moment().month() && to.year() == moment().year()) {
      to = moment();
    }

    let from: Moment = _.cloneDeep(month).date(1);
    switch (rolling) {
      case 'ONE_MONTH':
        from = _.cloneDeep(month).date(1);
        break;
      case 'THREE_MONTHS':
        from = _.cloneDeep(month).subtract(2, 'months').date(1);
        break;
      case 'SIX_MONTHS':
        from = _.cloneDeep(month).subtract(5, 'months').date(1);
        break;
      case 'TWELVE_MONTHS':
        from = _.cloneDeep(month).subtract(11, 'months').date(1);
        break;
      case 'YEAR_TO_DATE':
        from = _.cloneDeep(month).date(1).month(0);
        break;
      default:
        break;
    };

    const period: IPeriod = {
      from: this.getUnixTime(from),
      to: this.getUnixTime(to),
    };
    return period;
  }

  private getUnixTime(localMoment: Moment): number {

    const utcMoment = moment.utc({
      year: localMoment.year(),
      month: localMoment.month(), // 0-based
      date: localMoment.date(),
      hour: localMoment.hour(),
      minute: localMoment.minute(),
      second: localMoment.second(),
    });
    return utcMoment.valueOf();

  }
}

